module.exports = __webpack_public_path__ + "static/media/Illus-SummerLate@2x.cfa7921e.png";